import React, { lazy} from "react";
import { Navigate,} from "react-router-dom";
import { PATH } from "./utils/pagePath";
import PublicRoute from "./components/PublicRoute/PublicRoute";
import PrivateRoute from "components/ProtectedRoute/PrivateRoute";
import PreLogin from "./layouts/PreLogin/PreLogin";
import { CREATE_PROJECTS } from "services/endPoints";
import ViewErrorLogs from "pages/ErrorLogs/ViewErrorLogs";
const LazyCreateProject = lazy(() => import("pages/Project/CreateProject"));
const LazyBacklog = lazy(() => import("pages/Backlog/Backlog"));
const LazyActiveSprint = lazy(() => import("pages/ActiveSprint/ActiveSprint"));
const LazyCode = lazy(() => import("pages/Code/Code "));
const LazyProjectSetting = lazy(() =>
  import("pages/ProjectSetting/ProjectSetting")
);
const LazyTimelineSetting = lazy(() =>
  import("pages/TimelineSetting/Timeline")
);
const LazyProjectMembers = lazy(() =>
  import("pages/ProjectSetting/ProjectMembers")
);

const LazyReleaseDetails = lazy(() => import("pages/Releases/ReleaseDetails"));
const LazyProjects = lazy(() => import("pages/Project/Projects"));
const LazyRegister = lazy(() => import("pages/Register/Register"));
const LazySetPassword = lazy(() => import("pages/SetPassword/SetPassword"));
const LazyPostLogin = lazy(() => import("./layouts/PostLogin/PostLogin"));
const LazyLogin = lazy(() => import("./pages/Login/Login"));
// const LazyInvitation = lazy(() => import("./pages/Invitation/Invitaion"));
const LazyInvitationNew = lazy(() => import("./pages/SetPassword/SetPassword"));
const LazyViewWorkflow = lazy(() => import("./pages/ProjectSetting/ViewWorkflow"))
const LazyReleases = lazy(() => import("./pages/Releases/Releases"));
const LazyForgotPassword = lazy(() =>
  import("./pages/ForgotPassword/ForgotPassword")
);
const LazyOtpVerification = lazy(() =>
  import("./pages/OtpVerification/OtpVerification")
);
const LazyConfirmPassword = lazy(() =>
  import("./pages/ConfirmPassword/ConfirmPassword")
);
const LazyViewProfile = lazy(() => import("pages/Profile/ViewProfile"));
const LazyActiveSprintDetails = lazy(() =>
  import("pages/ActiveSprint/ActiveSprintDetails")
);
const LazySummary = lazy(() => import("pages/summary/Summary"));
// const LazyRoles = lazy(() => import("pages/Roles/Roles"));
const LazyUpdateTeamInfo = lazy(() =>
  import("pages/CreateTeam/UpdateTeamInfo")
);
const LazyDueDateExtension = lazy(() =>
  import("pages/DueDateExtension/DueDateExtension")
);

const LazyProjectAllMember = lazy(() =>
  import("pages/ProjectAllMembers/ProjectAllMember"));

const LazySupportCustomer = lazy(() =>
  import("pages/ProjectSetting/SupportCustomer")
);

const LazyProjectComponent = lazy(() => import("pages/ProjectComponent/ProjectComponent"));  

const ViewAllIssues = lazy(() => import("pages/Filters/viewAllIssues"));
const ErrorPage = lazy(() => import("components/ErrorPage/ErrorPage"));

const LazyCustomizeDsr = lazy(() => import("pages/CustomizeDsr/CustomizeDsr"));
const LazyTimesheet = lazy(() => import("pages/Timesheet/Timesheet"));

const LazyUserManagementRoles = lazy(() => import("pages/UserManagement/roles"));
const LazyGlobalRoles = lazy(() => import("pages/UserManagement/GlobalRoles"));
const LazyGlobalUserList = lazy(() => import("pages/UserManagement/GlobalUserList"));
const LazyTestCase = lazy(() => import("pages/TestCases/TestCases"));
const LazyTestCaseImportLogs = lazy(() =>
  import("pages/TestCases/TestCaseImportLogs")
);
const LazyTestRuns = lazy(() => import("pages/TestCases/TestRuns"));
const LazyTestRunDetails = lazy(() => import("pages/TestCases/TestRunDetails"));
const LazyTestRunCaseDetails = lazy(() =>
  import("pages/TestCases/TestRunCaseDetails")
);

const routerPMT = [
  {
    path: PATH.DEFAULT,
    element: <Navigate to={PATH.LOGIN} replace />,
  },
  {
    element: (
      <PublicRoute component={<PreLogin />}>
        {/* <LazyPreLogin /> */}
      </PublicRoute>
    ),
    children: [
      {
        path: PATH.LOGIN,
        element: <LazyLogin />,
      },
      {
        path: PATH.FORGOT_PASSWORD,
        element: <LazyForgotPassword />,
      },
      {
        path: PATH.REGISTER,
        element: <LazyRegister />,
      },
      {
        path: PATH.OTP_VERIFICATION,
        element: <LazyOtpVerification />,
      },
      {
        path: PATH.CONFIRM_PASSWORD,
        element: <LazyConfirmPassword />,
      },
      // {
      //   path: PATH.INVITATION,
      //   element: <LazyInvitation />,
      // },
      {
        path: PATH.INVITATION,
        element: <LazyInvitationNew />,
      },
      {
        path: PATH.SET_PASSWORD,
        element: <LazySetPassword />,
      },
    ],
  },
  {
    element: (
      <PrivateRoute component={<LazyPostLogin />}>
        {/* <LazyPostLogin /> */}
      </PrivateRoute>
    ),
    children: [
      {
        path: PATH.PROJECT_PLANNING,
        children: [
          {
            path: PATH.BACKLOG,
            element: <LazyBacklog />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: PATH.SUMMARY,
            element: <LazySummary />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: PATH.TIMELINE_SETTINGS,
            element: <LazyTimelineSetting />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: PATH.ACTIVE_SPRINT,
            element: <LazyActiveSprint />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: `${PATH.RELEASES}/:releaseId`,
            element: <LazyReleaseDetails />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: PATH.RELEASES,
            element: <LazyReleases />,
            handle: {
              parent: PATH.PROJECT_PLANNING
            }
          },
          {
            path: PATH.ACTIVE_SPRINT_DETAILS,
            element: <LazyActiveSprintDetails />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
          {
            path: PATH.ISSUES,
            element: <ViewAllIssues />,
            handle: {
              parent: PATH.PROJECT_PLANNING,
            },
          },
        ],
      },
      {
        path: PATH.DEVELOPMENT,
        children: [
          {
            path: PATH.CODE,
            element: <LazyCode />,
          },
        ],
      },
      {
        path: PATH.ADMIN,
        element: <ViewErrorLogs />,
      },
      // {
      //   path: PATH.SETTINGS,
      //   children: [
      //     {
      //       path: PATH.ROLES,
      //       element: <LazyRoles />,
      //     },
      //   ],
      // },
      {
        handle: {
          title: "Project details",
        },
        children: [
          {
            path: PATH.PROJECT_SETTINGS,
            element: <LazyProjectSetting />,
            handle: {
              parent: PATH.PROJECT_DETAILS,
            },
          },
          {
            path: PATH.PROJECT_COMPONENT,
            element: <LazyProjectComponent />,
            permission: "ROLE_ViewComponent",
            handle: {
              parent: PATH.PROJECT_DETAILS,
            },
          },
        ],
      },
       {
        handle: {
          title: "User management",
          
        },
        children: [
          {
            path: PATH.MEMBER_SETTINGS,
            element: <LazyProjectMembers />,
            handle: {
              parent: PATH.USER_MANAGEMENT,
            },
          },
          {
            path: PATH.USER_MANAGEMENT_ROLES,
            element: <LazyUserManagementRoles />,
            permission: "ROLE_ProjectRoleView",
            handle: {
              parent: PATH.USER_MANAGEMENT,
            },
          },
          {
            path: PATH.GLOBAL_USER_MANAGEMENT,
            element: <LazyGlobalRoles />,
            permission: "ROLE_ApplicationRoleView",
            handle: {
              parent: PATH.USER_MANAGEMENT,
            },
          }, 
          {
            path: PATH.USER_LIST,
            element: <LazyGlobalUserList />,
            permission: "ROLE_UserViewList",
            handle: {
              parent: PATH.USER_MANAGEMENT,
            },
          }, 
        ],
      },
      {
        path: PATH.VIEW_WORKFLOW,
        element: <LazyViewWorkflow />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        },
      },
      {
        path: PATH.TEST_CASE_IMPORT_LOGS,
        element: <LazyTestCaseImportLogs />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        },
      },
      {
        path : PATH.TEST_Case,
        element : <LazyTestCase />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        }
      },
      {
        path : PATH.TEST_RUN_DETAILS,
        element : <LazyTestRunDetails />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        }
      },
      {
        path: PATH.TEST_RUN_CASE_DETAILS,
        element: <LazyTestRunCaseDetails />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        },
      },
      {
        path : PATH.TEST_RUN,
        element : <LazyTestRuns />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        }
      },
      {
        path: PATH.CUSTOMERS,
        element: <LazySupportCustomer />,
        handle: {
          parent: PATH.PROJECT_PLANNING,
        },
      },
      {
        path: PATH.PROJECTS,
        children: [
          // {
          //     path: PATH.CREATE_PROJECTS,
          //     element: <LazyCreateProject />
          // },
          {
            path: PATH.PROJECTS,
            element: <LazyProjects />,
          },
          {
            path: PATH.PROJECT_ALL_MEMBER,
            element: <LazyProjectAllMember />
          },
          {
            path: `${PATH.PROJECTS}/teams/:id`,
            element: <LazyUpdateTeamInfo />,
          },
          {
            path: `${PATH.PROJECTS}/filter/view-all-issues`, // New route
            element: <ViewAllIssues />,
          },
        ],
      },
      {
        path: PATH.PROFILE_VIEWPROFILE,
        children: [
          {
            path: PATH.PROFILE_VIEWPROFILE,
            element: <LazyViewProfile />,
          },
        ],
      },
      // {
      //   path: `${PATH.TEAMS}/:id` ,
      //   element: <UpdateTeamInfo/>,
      // },
      
    ],
  },

  {
    path: CREATE_PROJECTS,
    element: <LazyCreateProject />,
  },
  {
    path: `${PATH.ERRORPAGE}/:id`,
    element: <ErrorPage />,
  },
  {
    path: PATH.DUEDATEREQUEST,
    element: <LazyDueDateExtension />,
  },
  {
    path: PATH.CUSTOMIZE_DSR,
    element: <PrivateRoute component={<LazyCustomizeDsr />} />,
  },
  {
    path: PATH.TIMESHEET,
    element: <PrivateRoute component={<LazyTimesheet />} />,
  },
];

export default routerPMT